import { ReactElement } from "react";
import { Col, Form } from "react-bootstrap";

export interface ISelectOption {
    value: string,
    title: string
}

export enum DataType {
    String = 1,
    Number = 2,
    Boolean = 3,
    Date = 4
}

export interface IFormFieldProps {
    title: string | ReactElement;
    extraContent?: string | ReactElement;
    onChange: (newVal: string) => void;
    value?: string;
    className?: string;
    readOnly?: boolean;
    changeTracker?: (changed: boolean) => void;
}

export const TextField = (props: IFormFieldProps) =>
    <Col>
        <Form.Group className={`mb-3 ${props.className}`}>
            <Form.Label>{props.title}</Form.Label>
            {
                props.extraContent
            }
            {
                <Form.Control
                    type="text"
                    readOnly={props.readOnly || false}
                    onChange={
                        (e) => {
                            if (props.changeTracker) {
                                props.changeTracker(true);
                            }

                            props.onChange(e.target.value);
                        }}
                    value={props.value}
                />
            }
        </Form.Group>
    </Col>;